import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import type { WorkspaceDerivedItem } from '../../services/kpWorkspaceService';
import { buildKnowledgeParticleDetailPath } from '../../utils/knowledgeNavigation';
import {
  TtqWorkbenchFocusLayout,
  type TtqWorkbenchFocusEmphasis,
} from './TtqWorkbenchFocusLayout';

type TtqWorkbenchSplitLayoutProps = {
  /** @deprecated 使用 split */
  hasDerived?: boolean;
  split?: boolean;
  source: ReactNode;
  actions?: ReactNode;
  derived: ReactNode;
  leftLabel?: string;
  rightLabel?: string;
  emphasis?: TtqWorkbenchFocusEmphasis;
  onEmphasisChange?: (emphasis: TtqWorkbenchFocusEmphasis) => void;
};

/** @deprecated 使用 TtqWorkbenchFocusLayout */
export function TtqWorkbenchSplitLayout({
  actions: _actions,
  leftLabel: _leftLabel,
  rightLabel: _rightLabel,
  onEmphasisChange: _onEmphasisChange,
  hasDerived,
  split,
  ...layoutProps
}: TtqWorkbenchSplitLayoutProps) {
  return <TtqWorkbenchFocusLayout {...layoutProps} split={split ?? hasDerived ?? false} />;
}

export { TtqWorkbenchFocusLayout, type TtqWorkbenchFocusEmphasis };

type TtqWorkbenchDerivedListProps = {
  title?: string;
  items: WorkspaceDerivedItem[];
  emptyText?: string;
  returnTo?: string;
};

export function TtqWorkbenchDerivedList({
  title = '衍生知识颗粒',
  items,
  emptyText = '暂无衍生颗粒',
  returnTo,
}: TtqWorkbenchDerivedListProps) {
  return (
    <section className="rounded-xl border border-border bg-surface p-3 shadow-sm">
      <p className="mb-2 text-xs font-semibold text-ink">{title}</p>
      {items.length === 0 ? (
        <p className="text-sm text-muted">{emptyText}</p>
      ) : (
        <ul className="max-h-[calc(100vh-12rem)] space-y-2 overflow-y-auto pr-1">
          {items.map((item) => (
            <li key={item.id} className="rounded-lg border border-border bg-canvas p-3 text-sm">
              <p className="font-medium text-ink">{item.title || '衍生颗粒'}</p>
              {item.question ? (
                <p className="mt-1 line-clamp-4 whitespace-pre-wrap text-xs text-muted">{item.question}</p>
              ) : null}
              {item.particleId ? (
                <Link
                  to={buildKnowledgeParticleDetailPath(item.particleId, returnTo)}
                  className="mt-2 inline-block text-xs text-primary hover:underline"
                >
                  查看颗粒
                </Link>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
